import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const TaskCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        border: `1px solid ${theme.customColors.border.main}`,
        borderRadius: "10px",
        p: 2,
      }}
    >
      <Skeleton
        variant="text"
        width="90%"
        height={24}
        sx={{ mb: 1.5 }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ borderRadius: "6px" }}
      />
    </Box>
  );
};

export default TaskCardSkeleton;

